export var BogTransactionStatusReasonEnum;
(function (BogTransactionStatusReasonEnum) {
    BogTransactionStatusReasonEnum["MISSING_FIELDS"] = "MISSING_FIELDS";
    BogTransactionStatusReasonEnum["USER_MISMATCH"] = "USER_MISMATCH";
    BogTransactionStatusReasonEnum["DUPLICATE_TRANSACTION"] = "DUPLICATE_TRANSACTION";
    BogTransactionStatusReasonEnum["MISMATCHED_STATUS"] = "MISMATCHED_STATUS";
    BogTransactionStatusReasonEnum["INVALID_TYPE"] = "INVALID_TYPE";
    BogTransactionStatusReasonEnum["MERCHANT_TRANSACTION"] = "MERCHANT_TRANSACTION";
    BogTransactionStatusReasonEnum["BANK_TRANSACTION"] = "BANK_TRANSACTION";
    BogTransactionStatusReasonEnum["INTERNAL_TRANSACTION"] = "INTERNAL_TRANSACTION";
    BogTransactionStatusReasonEnum["EXTERNAL_TRANSACTION"] = "EXTERNAL_TRANSACTION";
    BogTransactionStatusReasonEnum["OTHER"] = "OTHER";
})(BogTransactionStatusReasonEnum || (BogTransactionStatusReasonEnum = {}));
//# sourceMappingURL=bog-transaction-status-reason.enum.js.map